import { render } from "./OfflinePage.vue?vue&type=template&id=2250e7b7&scoped=true"
import script from "./OfflinePage.vue?vue&type=script&lang=js"
export * from "./OfflinePage.vue?vue&type=script&lang=js"

import "./OfflinePage.vue?vue&type=style&index=0&id=2250e7b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2250e7b7"]])

export default __exports__